<template>
  <div>
    <v-stepper-step :complete="currentStep > 1" step="1">
      <h3>WHERE IS YOUR ITEM GOING?</h3>
      <div v-show="currentStep == 1" class="text-caption">
        <p>
          <span class="red--text"><strong>* </strong></span>= Mandatory field
        </p>
      </div>
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-form v-model="recipientFormValid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.name"
              :rules="nameRules"
              :counter="14"
              label="First Name"
              placeholder="First Name"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>FIRST NAME:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.surname"
              :rules="lastNameRules"
              :counter="20"
              label="Last Name"
              placeholder="Last Name"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>LAST NAME:
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.addressLine1"
              :rules="addressLine1Rules"
              label="Address Line 1"
              placeholder="Address Line 1"
              :counter="50"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>ADDRESS LINE
                  1:
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="recipient.addressLine2"
              label="Address Line 2"
              placeholder="Address Line 2"
              :counter="50"
              :rules="addressLine2Rules"
            >
              <template #label>
                <h3 class="black--text">ADDRESS LINE 2:</h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon postCode"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.postcode"
              :rules="postcodeRules"
              label="Post Code"
              placeholder="Post Code"
              :counter="17"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>POST CODE:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.locality"
              :rules="localityRules"
              :counter="35"
              label="Locality"
              placeholder="Locality"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>LOCALITY:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              :items="countries"
              label="Country"
              item-text="name"
              item-value="id"
              placeholder="Country"
              v-model="recipient.countryId"
              :rules="countryRules"
                required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>COUNTRY:
                </h3>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="recipient.email"
              :rules="emailRules"
              :counter="50"
              label="E-mail"
              placeholder="E-mail of addressee"
            >
              <template #label>
                <h3 class="black--text">E-MAIL:</h3>
              </template></v-text-field
            >
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="recipient.phone"
              :rules="phoneRules"
              :counter="20"
              label="Phone"
              placeholder="Phone of addressee"
            >
              <template #label>
                <h3 class="black--text">PHONE:</h3>
              </template></v-text-field
            >
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="recipient.vatNumber"
              :rules="vatNumberRecipientRules"
              :counter="20"
              label="VAT Number"
              placeholder="VAT Number of addressee"
            >
              <template #label>
                <h3 class="black--text">VAT NUMBER:</h3>
              </template></v-text-field
            >
          </v-col>
        </v-row>
      </v-form>
      <v-btn color="primary" @click="goNext()" :disabled="!recipientFormValid">
        Next
      </v-btn>      
    </v-stepper-content>
  </div>
</template>
<script>
import validationRules from "../../helpers/ValidationRules";
import customsRules from "../../helpers/CustomsRules";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapDeclarationGetters } = createNamespacedHelpers(
  "declarations"
);

export default {
  name: "Step01Recipient",
  data() {
    return {
      recipientFormValid: false,
      recipient: {
        name: "",
        surname: "",
        email: "",
        addressLine1: "",
        addressLine2: "",
        postcode: "",
        locality: "",
        countryId: "",
        phone: "",
        vatNumber: "",
        isRequiresContentItems: false,
      },
      ...validationRules,
    };
  },
  computed: {
    ...mapDeclarationGetters(["countries"]),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("declarations/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["declarations/currentStep"];
      },
    },
  },
  methods: {
    goNext() {
      if (!this.recipient.email && !this.recipient.phone){
        this.$store.dispatch("declarations/showRequiredEmailOrPhoneError");
      }
      else {
        const countryId = this.recipient.countryId;
        const {
          stepNumber: nextStep,
          isRequiresContentItems,
        } = customsRules.afterRecipientGoTo(countryId, this.countries);

        this.recipient.isRequiresContentItems = isRequiresContentItems;

        this.$store.dispatch(
          "declarations/Step01Recipient/setRecipient",
          this.recipient
        );

        this.$store.dispatch("declarations/setCurrentStep", nextStep);
      }
    },
  },
  mounted() {},
};
</script>